import pkg from '../../package.json';

export const common = {
  name: 'rcc.frontend',
  version: '0.0.0',
  appPrefix: require('../../package.json').deployment.appPrefix,
  indexUrl: 'index.html',
};

export const PROD_MEDALLIA_ENV = {
  MEDALLIA_HTML: 'https://mdl-medallia-digital.vanguard.com/pkg/1.0.0/web/FAS_external_libs/',
  MEDALLIA_JS:
    'https://mdl-medallia-digital.vanguard.com/pkg/1.0.0/web/FAS_external_libs/wdcusprem/8759/onsite/medallia-digital-embed.js',
  MEDALLIA_SURVEY_ID: 4402,
  MEDALLIA_REDESIGN_SURVEY_ID: 15393,
};

export const NON_PROD_MEDALLIA_ENV = {
  MEDALLIA_HTML:
    'https://mdl-medallia-digital-angular-external.ecs.us-east-1.esst.c1.vanguard.com/pkg/1.0.0/web/FAS_external_libs/',
  MEDALLIA_JS:
    'https://mdl-medallia-digital-angular-external.ecs.us-east-1.esst.c1.vanguard.com/pkg/1.0.0/web/FAS_external_libs/wdcusprem/8759/onsite/medallia-digital-embed.js',
  MEDALLIA_SURVEY_ID: 4401,
  MEDALLIA_REDESIGN_SURVEY_ID: 15267,
};

export const NON_PROD_ADOBE_ENV = {
  ADOBE_FASMKT_JS: 'https://advisors.webt.vanguard.com/adobe_fasmkt.js',
  ADOBE_CONTAINER:
    'https://corp-etm-arl.webt.vanguard.com/fas/379f26abac75/74315b3499e2/launch-98b4a07d4bd4-staging.min.js',
  AEM_CAAS_ENDPOINT: 'https://test-caas.vanguard.com/content/fas/digital/rcc/public.caasv3.json',
};

export const PROD_ADOBE_ENV = {
  ADOBE_FASMKT_JS: 'https://advisors.web.vanguard.com/adobe_fasmkt.js',
  ADOBE_CONTAINER:
    'https://corp-etm-arl.web.vanguard.com/fas_prd/379f26abac75/74315b3499e2/launch-02c257bd248a.min.js',
  AEM_CAAS_ENDPOINT: 'https://caas.vanguard.com/content/fas/digital/rcc/public.caasv3.json',
};

export const internal = {
  UserLocation: 'internal',
};

export const external = {
  UserLocation: 'external',
};

export const prodNodeEnv = pkg.deployment.properties['production-us-east-1'].env;
export const nonProdNodeEnv = pkg.deployment.properties['test-us-east-1'].env;
export const devNodeEnv = pkg.deployment.properties['development-us-east-1'].env;
